import { render, staticRenderFns } from "./order-product-image.vue?vue&type=template&id=3c4bbf5b"
import script from "./order-product-image.vue?vue&type=script&lang=js"
export * from "./order-product-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports